// extracted by mini-css-extract-plugin
export default {"back":"j011p","icon":"NVjgL"};